import React from 'react';
import { useAuth } from '../context/AuthContext';
import { surveyLink } from '../utils/surveyLink';

const teacherSurveys = [
  {
    title: 'Teacher Baseline Survey',
    description: 'Share your starting experience with tracking and supporting student learning.',
    url: 'https://docs.google.com/forms/d/e/1FAIpQLSdH9-4EJeGD3CjxA6TwhYLm0IDNGyPe1nuFfkK6AwKMFBLlSg/viewform?usp=header',
  },
  {
    title: 'Teacher Monthly Survey',
    description: 'Share your monthly feedback on using Academic Eye.',
    url: 'https://docs.google.com/forms/d/e/1FAIpQLSeNd9bCrBRYvHrU5v1ibIRrkZVkw2nrUUYDbcQzkGIiVN6TDQ/viewform?usp=publish-editor',
  },
];

export default function SurveysComingSoon({ audience }: any) {
  const { user } = useAuth();
  const email = user?.email || '';
  const isTeacher = audience === 'teacher';
  return (
    <section
      aria-label="Surveys"
      style={{
        width: '100%',
        maxWidth: 720,
        boxSizing: 'border-box',
        padding: 24,
        borderRadius: 18,
        background: 'var(--ae-surface)',
        border: '1px solid var(--ae-border)',
        boxShadow: 'var(--ae-shadow-card)',
      }}
    >
      <h1 style={{ margin: '0 0 12px', fontSize: 28, fontWeight: 800, color: 'var(--ae-primary-strong)' }}>
        Surveys
      </h1>
      {isTeacher ? (
        <>
          <p style={{ color: 'var(--ae-text-muted)', lineHeight: 1.6 }}>
            Share your experience with Academic Eye. Each survey opens in a new tab
            {email ? <> with your account email (<strong>{email}</strong>) prefilled.</> : '. Enter your email in the form if requested.'}
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 250px), 1fr))', gap: 16 }}>
            {teacherSurveys.map((survey) => (
              <article key={survey.title} style={{ padding: 18, border: '1px solid var(--ae-border)', borderRadius: 14, background: 'var(--ae-surface-soft)' }}>
                <h2 style={{ margin: '0 0 8px', fontSize: 19, color: 'var(--ae-primary-strong)' }}>{survey.title}</h2>
                <p style={{ color: 'var(--ae-text-muted)', lineHeight: 1.6 }}>{survey.description}</p>
                <a href={surveyLink(survey.url, email)} target="_blank" rel="noopener noreferrer" aria-label={`Take the ${survey.title}`}>
                  Take survey
                </a>
              </article>
            ))}
          </div>
        </>
      ) : (
        <>
          <p style={{ margin: '0 0 12px', fontSize: 16, fontWeight: 600, color: 'var(--ae-text-muted)' }}>
            Coming soon
          </p>
          <p style={{ margin: 0, color: 'var(--ae-text-muted)', lineHeight: 1.6 }}>
            Periodic surveys will be available here when they are ready.
          </p>
        </>
      )}
    </section>
  );
}
